import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'
import NotifConnectionRequestBox from '../boxes/NotifConnectionRequestBox'

class RequestsInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            if (value == '') {
                value = null
            }
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }


    render() {
        let data = this.props.data
        let fullData = this.props.fullData
        return (
            <div className="w-100 h-100"  >
                {Array.isArray(data) && data.map((item, index) => {

                    let notifData = {
                        connectionType: item.connectionType,
                        form: item.form,
                        hub: fullData?.hub,
                        extra: { ref: item._id }
                    }

                    return (
                        <div key={item._id} className='pb-1' style={{ borderBottom: index < data.length - 1 ? '1px solid #eee' : '' }}>
                            <NotifConnectionRequestBox data={notifData} addNewWindow={this.props.addNewWindow} isInInput={true} />
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default RequestsInput;